import { z } from 'zod';

/**
 * Схемы Answer для API контракта (Веха 3).
 *
 * Источник правды:
 *   - CANON §2.D (zod-strict): все .strict().
 *   - threat-models/api.md → T (max-length для text).
 *   - work/003 §4: `Answer.cardImageUrl` остаётся null в Вехе 3 — рендер
 *     карточки делает Веха 5 (Satori → S3). Поэтому в response пока nullable.
 *
 * Лимиты: text.max(1000) — формат «ответ с описанием»; questionId.max(64) —
 * Prisma cuid ≈ 25 chars + запас под будущие id-схемы.
 */
export const CreateAnswerBody = z
  .object({
    questionId: z.string().min(1).max(64),
    text: z.string().min(1).max(1000),
  })
  .strict();
export type CreateAnswerBody = z.infer<typeof CreateAnswerBody>;

/**
 * View ответа для эндпоинтов (response `POST /answers` + вложенный в `GET /inbox`).
 *
 * text — nullable: владелец может оставить голый ответ только с карточкой
 * (когда Веха 5 расскроет визуальный формат). cardImageUrl — nullable в Вехе 3
 * (Веха 5 заполнит). sharedToStory — флаг, отправлял ли владелец карточку в
 * Telegram Stories (нужен для дедупа кнопки «поделиться»).
 */
export const AnswerView = z
  .object({
    id: z.string(),
    text: z.string().nullable(),
    cardImageUrl: z.string().url().nullable(),
    sharedToStory: z.boolean(),
    createdAt: z.string().datetime(),
  })
  .strict();
export type AnswerView = z.infer<typeof AnswerView>;
